import { Component, OnInit } from '@angular/core';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { TableParams } from 'src/app/components/grid/TableParams';
import { IExam, IImportExamCandidate } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { GenericConfirmComponent } from 'src/app/shared-layout/generic-confirm/generic-confirm.component';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { SebInstructionUrlComponent } from '../seb-instruction-url/seb-instruction-url.component';
import { map, of, startWith, switchMap, take, tap } from 'rxjs';

@Component({
  selector: 'app-import-schedule-candidate',
  templateUrl: './import-schedule-candidate.component.html',
  styleUrls: ['./import-schedule-candidate.component.scss']
})
export class ImportScheduleCandidateComponent implements OnInit {

  exam: IExam = examDefault;

  uploadFile: IImportExamCandidate = {
    examinationID: 0,
    notifyCandidatesByEmail: false,
    gapPerBatch: 0,
    capacityPerSlot: 0,
    file: null,
    batchStartDateTime: null,
    batchEndDateTime: null,
    candidateList: ''
  }
  candidateCount: number = 0;
  constructor(private popoverRef: PopoverRef<ImportScheduleCandidateComponent>, private popoverService: PopoverService,
    private examService: ExamService, private snackBar: SnackbarService, private candidateService: CandidateService) { }


  async ngOnInit() {
    this.exam = this.examService.selectedExams[0];
    this.candidateCount = (await this.candidateService.getCandidateCount()).data;
  }

  onFileChange(event: any) {
    this.uploadFile.file = undefined;
    if (event.target.files && event.target.files[0]) {
      this.uploadFile.file = event.target.files[0];
    }
  }

  close() {
    this.popoverRef.close();
  }

  async uploadFileCandidate(origin: any) {
    this.uploadFile.examinationID = this.exam.id;
    if (!this.validateImportForm()) {
      return;
    }

    if (!this.uploadFile.file && !this.uploadFile.candidateList) {
      const popover = this.popoverService.open({
        content: GenericConfirmComponent,
        origin: origin,
        width: 2000,
        offsetY: 12,
        data: { message: 'You are about to Schedule ' + this.candidateCount + ' candidates. \nAre you sure you want to proceed?' },
        position: [
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'top'
          }, {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'top'
          }
        ]
      });

      popover.afterClosed$
        .pipe(take(1))
        .subscribe(async (result: any) => {
          if (result.data === true) {
            await this.examService.uploadCandidate(this.getFormData()).then(s => {
              this.snackBar.success('Candidates Scheduled');
              this.close();
            });
          }
        });
    } else {
      await this.examService.uploadCandidate(this.getFormData()).then(s => {
        this.snackBar.success('Candidates Scheduled');
        this.close();
      });
    }
  }

  validateImportForm() {
    // if (!this.uploadFile.file) {
    //   this.snackBar.warning("File is required");
    //   return false;
    // }
    // if (!this.uploadFile.batchStartDateTime) {
    //   this.snackBar.warning("Batch Start Date is required");
    //   return false;
    // }
    // if (!this.uploadFile.batchEndDateTime) {
    //   this.snackBar.warning("Batch End Date is required");
    //   return false;
    // }
    if (this.uploadFile.capacityPerSlot === 0) {
      this.snackBar.warning("Capacity is required");
      return false;
    }
    // if (this.uploadFile.gapPerBatch === 0) {
    //   this.snackBar.warning("Gap is required");
    //   return false;
    // }

    return true;
  }
  getFormData(): FormData {
    const formData = new FormData();
    Object.keys(this.uploadFile).forEach((key) => {
      const value = (this.uploadFile as any)[key];
      if (value === null || value === undefined) {
        formData.append(key, '');
      } else {
        formData.append(key, value);
      }
    });
    return formData;
  }

}
